import React from "react";
import { Tabs } from "antd-mobile";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import StatisqueGraph from "../statistique/StatisqueGraph";
// import { Help } from "../../utils";

export default function AllStatistiqueBien({
  dataset,
  dataSeries,
  titleStatitisque,
  titleStatitisqueDormant,
  dataSeriesIndisponible,
  datasetIndisponible,
}) {
  return (
    <>
      <FilterByBienLocation
        dataset={dataset}
        dataSeriesIndisponible={dataSeriesIndisponible}
        datasetIndisponible={datasetIndisponible}
        titleStatitisque={titleStatitisque}
        titleStatitisqueDormant={titleStatitisqueDormant}
        dataSeries={dataSeries}
      />
    </>
  );
}

const FilterByBienLocation = ({
  dataset,
  dataSeries,
  titleStatitisque,
  titleStatitisqueDormant,
  dataSeriesIndisponible,
  datasetIndisponible,
}) => {
  const chartSetting = {
    yAxis: [
      {
        label: "Total",
        tickMinStep: 1,
      },
    ],
    width: 960,
    height: 370,
    sx: {
      padding: "20px 10px 30px 15px",
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-20px, 0)",
      },
    },
  };
  // console.log("StatisqueGraph_disponible", dataset);
  return (
    <Tabs>
      <Tabs.Tab title={titleStatitisque} key={titleStatitisque}>
        <StatisqueGraph
          dataset={dataset}
          chartSetting={chartSetting}
          series={dataSeries}
        />
      </Tabs.Tab>
      <Tabs.Tab title={titleStatitisqueDormant} key={titleStatitisqueDormant}>
        <StatisqueGraph
          dataset={datasetIndisponible}
          chartSetting={chartSetting}
          series={dataSeriesIndisponible}
        />
      </Tabs.Tab>
    </Tabs>
  );
};
